import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { StatisticsState, Statistics, StatisticsList, Search, ScrollOptions } from './types';
import { RootState } from '../types';

export const defaultStatistics = (): Statistics => {
  return {
    parkingLotStatisticsAvgDto: {
      allianceAvg: '0.00',
      bizHourcd24Avg: '0.00',
      bizHourcdHolAvg: '0.00',
      bizHourcdNotAvg: '0.00',
      bizHourcdTimeAvg: '0.00',
      comRegisterAvg: '0.00',
      generalAvg: '0.00',
      intervalFreeAvg: '0.00',
      intervalNotAvg: '0.00',
      intervalPayAvg: '0.00',
      newExpansionNoAvg: '0.00',
      newExpansionYesAvg: '0.00',
      satHourcd24Avg: '0.00',
      satHourcdHolAvg: '0.00',
      satHourcdNotAvg: '0.00',
      satHourcdTimeAvg: '0.00',
      sunHourcd24Avg: '0.00',
      sunHourcdHolAvg:'0.00',
      sunHourcdNotAvg: '0.00',
      sunHourcdTimeAvg: '0.00',
      syncAvg: '0.00',
      syncNoAvg: '0.00',
      temporaryNyAvg: '0.00',
      totalAvg: '0.00',
      totalNumNoAvg: '0.00',
      totalNumYesAvg: '0.00'
    },
    parkingLotStatisticsDto: {
      alliance: 0,
      bizHourcd24: 0,
      bizHourcdHol: 0,
      bizHourcdNot: 0,
      bizHourcdTime: 0,
      comRegister: 0,
      general: 0,
      intervalFree: 0,
      intervalNot: 0,
      intervalPay: 0,
      newExpansionNo: 0,
      newExpansionYes: 0,
      satHourcd24: 0,
      satHourcdHol: 0,
      satHourcdNot: 0,
      satHourcdTime: 0,
      sunHourcd24: 0,
      sunHourcdHol: 0,
      sunHourcdNot: 0,
      sunHourcdTime: 0,
      sync: 0,
      syncNo: 0,
      temporaryNy: 0,
      total: 0,
      totalNumNo: 0,
      totalNumYes: 0
    }
  }
}

export const defaultLists = (): StatisticsList => {
  return {
    paging: {
      currentPage: 1,
      limit: 20,
      offset: 0,
      pageCount: 0,
      totalCount: 0
    },
    parkingLotStatisticsListDtoList: []
  }
}

export const defaultParameters = (): Search => {
  return {
    searchCategory: '등록자명',
    searchWord: '',
    startDate: null,
    endDate: null,
    state: null,
    parkinglotType: null,
    newExpansion: null,
    totalNum: null,
    bizHourCd: null,
    satBizHourCd: null,
    sunHolBizHourCd: null,
    intervalFreeNy: null,
    sort: '등록일순'
  }
}

export const defaultScrollOptions = (): ScrollOptions => {
  return {
    callbackFn: () => {},
    scrollBind: false
  }
}

export const state: StatisticsState = {
  list: defaultLists(),
  statistics: defaultStatistics(),
  parameters: defaultParameters(),
  scrollOptions: defaultScrollOptions()
}

const namespaced: boolean = true;

export const statistics: Module<StatisticsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
